// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const arctozolt: PokeData = {
  "id": 881,
  "name": "arctozolt",
  "height": 23,
  "weight": 1500,
  "base_experience": 177,
  "types": [
    PokeType.ELECTRIC,
    PokeType.ICE
  ],
  "api_moves": [
    "slam",
    "blizzard",
    "thunder-shock",
    "powder-snow",
    "ancient-power",
    "charge",
    "pluck",
    "avalanche",
    "discharge",
    "echoed-voice",
    "icicle-crash",
    "freeze-dry",
    "bolt-beak"
  ],
  "moves": [
    "blizzard",
    "thunder-shock",
    "ancient-power",
    "avalanche",
    "ice-shard",
    "thunderbolt",
    "ice-punch",
    "aurora-veil",
    "hailstorm",
    "icicle-dagger",
    "ice-wave",
    "thunder-fang",
    "wild-charge"
  ],
  "evolution_chain": {
    "id": 462,
    "item": null,
    "species": [
      {
        "name": "arctozolt",
        "order": 881,
        "types": [
          PokeType.ELECTRIC,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 144,
    "speed": 91,
    "ability_power": 165
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
